import { Component, OnInit, AfterViewInit, inject, isDevMode } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { MobileSidebarComponent } from '../mobile-sidebar/mobile-sidebar.component';
import { FooterComponent } from '../footer/footer.component';
import { MENU_DATA, MenuItem } from '../sidebar/menu-data';

@Component({
  selector: 'app-two-column-layout',
  standalone: true,
  imports: [
    CommonModule, 
    RouterModule, 
    HeaderComponent, 
    SidebarComponent, 
    MobileSidebarComponent, 
    FooterComponent
  ],
  template: `
    <div id="layout-wrapper">
      <app-header></app-header>
      
      <!-- Sidebar para Escritorio -->
      <app-sidebar class="d-none d-lg-block"></app-sidebar>
      
      <!-- Sidebar especial para Móvil -->
      <app-mobile-sidebar class="d-lg-none"></app-mobile-sidebar>
      
      <div class="main-content">
        <div class="page-content">
          <div class="container-fluid">
            <router-outlet></router-outlet>
          </div>
        </div>
        <app-footer></app-footer>
      </div>
    </div>
  `
})
export class TwoColumnLayoutComponent implements OnInit, AfterViewInit {
  private router = inject(Router);

  ngOnInit() {
    this.setLayoutAttributes();
    // El panel iniciará expandido por defecto gracias a LayoutService

    // Si no estamos en desarrollo, interceptar rutas en construcción y redirigir
    if (!isDevMode()) {
      this.router.events.pipe(
        filter(event => event instanceof NavigationStart)
      ).subscribe((event: any) => {
        const url = event.url;
        if (url && !url.startsWith('/en-construccion') && this.isRouteUnderConstruction(url)) {
          this.router.navigate(['/en-construccion'], { queryParams: { from: url } });
        }
      });

      // Verificar la ruta actual de inmediato en caso de carga inicial
      const currentUrl = this.router.url;
      if (currentUrl && !currentUrl.startsWith('/en-construccion') && this.isRouteUnderConstruction(currentUrl)) {
        this.router.navigate(['/en-construccion'], { queryParams: { from: currentUrl } });
      }
    }
  }

  ngAfterViewInit() {
    this.initSessionStorage();
    if ((window as any).feather) {
      (window as any).feather.replace();
    }
  }

  private setLayoutAttributes() {
    const html = document.documentElement;
    html.setAttribute('data-layout', 'twocolumn');
    html.setAttribute('data-layout-style', 'default');
    html.setAttribute('data-sidebar', 'dark');
    html.setAttribute('data-topbar', 'light');
    html.setAttribute('data-sidebar-size', 'lg');
    html.setAttribute('data-sidebar-image', 'none');
    html.setAttribute('data-preloader', 'disable');
    html.setAttribute('data-layout-width', 'fluid');
    html.setAttribute('data-layout-position', 'fixed');
  }

  private initSessionStorage() {
    const keys = [
      'data-layout', 'data-sidebar-size', 'data-bs-theme',
      'data-layout-width', 'data-sidebar', 'data-sidebar-image',
      'data-layout-direction', 'data-layout-position',
      'data-layout-style', 'data-topbar', 'data-preloader'
    ];
    keys.forEach(key => {
      const val = document.documentElement.getAttribute(key);
      if (val) sessionStorage.setItem(key, val);
    });
  }

  private isRouteUnderConstruction(url: string): boolean {
    const cleanUrl = url.split('?')[0];
    
    const findInItems = (items: MenuItem[]): boolean => {
      for (const item of items) {
        if (item.route && item.route.split('?')[0] === cleanUrl) {
          return !!item.enConstruccion;
        }
        if (item.children && findInItems(item.children)) {
          return true;
        }
      }
      return false;
    };

    for (const section of MENU_DATA) {
      if (findInItems(section.children)) {
        return true;
      }
    }
    return false;
  }
}
